import * as React from 'react';
import { useSwiper } from 'swiper/react';

interface ISwiperButtonPrevProps {
  children: React.ReactNode;
  className?: string;
}

const SwiperButtonPrev: React.FunctionComponent<ISwiperButtonPrevProps> = ({
  className,
  children,
}) => {
  const swiper = useSwiper();
  const handleClick=(e: React.MouseEvent)=>{
    e.stopPropagation();
    swiper.slidePrev()
  }
  return (
    <button className={`${className} flex items-center`} onClick={handleClick}>
      {children}
    </button>
  );
};

export default SwiperButtonPrev;
